import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Components
import { AdminareaComponent } from './components/adminarea/adminarea.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { PredictionsComponent } from './components/predictions/predictions.component';
import { GroupsComponent } from './components/groups/groups.component';
import { MatchesComponent } from './components/matches/matches.component';
import { TeamsComponent } from './components/teams/teams.component';
import { StadiumsComponent } from './components/stadiums/stadiums.component';
import { NewsComponent } from './components/news/news.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
// Guard
import { AuthGuard } from './auth.guard';
 
const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'predictions', component: PredictionsComponent, canActivate: [ AuthGuard ] },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'groups', component: GroupsComponent },
  { path: 'matches', component: MatchesComponent },
  { path: 'teams', component: TeamsComponent },
  { path: 'stadiums', component: StadiumsComponent },
  { path: 'news', component: NewsComponent },
  { path: 'admin', component: AdminareaComponent },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts